// Module
var code = "<react-component name=\"PosSale\"></react-component>\n";
// Exports
module.exports = code;